/** FareHarbor's module for the easy flow: its words. Its one credential field (`user_key`)
 *  comes from the backend; the console words it for ops. */
import type { EasyRestechModule } from '../registry';

export const FAREHARBOR: EasyRestechModule = {
  code: 'fareharbor',
  vendor: 'FareHarbor',
  products: 'products',
  fieldWords: {
    user_key: {
      label: 'FareHarbor user key',
      hint: 'Paste the key the operator gave you — it is checked with FareHarbor straight away.',
    },
  },
  // Its support team registers our webhook, asked by email.
  webhookSetup: 'email',
};
